var $c84141546cea1186$exports = {};
$c84141546cea1186$exports = {
    "colorFormat": `Barevn\xfd form\xe1t`,
    "hex": `Hex`,
    "hsb": `HSB`,
    "hsl": `HSL`,
    "rgb": `RGB`
};


export {$c84141546cea1186$exports as default};
//# sourceMappingURL=cs-CZ.mjs.map
